import { Component } from '@angular/core';

@Component({
  selector: 'app-gestion-preguntas-frecuentes',
  templateUrl: './gestion-preguntas-frecuentes.component.html',
  styleUrl: './gestion-preguntas-frecuentes.component.scss'
})
export class GestionPreguntasFrecuentesComponent {

}
